import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { Button, TableCell, TableRow, Typography } from '@mui/material';

import { LinkText } from 'common/components';
import { DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';

import { isEven } from 'utils/helpers';
import { colors } from 'themes';

const TargetGroupItem = ({ handleRemoveTargetGroup, index, name, uuid }) => {
  const { organizationUuid } = useParams();

  return (
    <TableRow sx={{ backgroundColor: isEven(index) ? colors.alabaster : colors.white }}>
      <TableCell sx={{ fontWeight: 'bold' }}>
        <LinkText color="inherit" to={`/${organizationUuid}/target-groups/${uuid}`}>
          <Typography variant="body1">{name}</Typography>
        </LinkText>
      </TableCell>
      <TableCell align="right">
        <Button
          color="error"
          onClick={() => handleRemoveTargetGroup(uuid)}
          startIcon={<DeleteOutlineIcon />}
        >
          Delete
        </Button>
      </TableCell>
    </TableRow>
  );
};

TargetGroupItem.propTypes = {
  handleRemoveTargetGroup: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
};

export default TargetGroupItem;
